/** Public Instagram profile URL - opens without referrer when used with noreferrer policy. */
export function instagramProfileUrl(username: string): string {
  const handle = username.trim().replace(/^@+/, "").toLowerCase();
  if (!handle) return "https://www.instagram.com/";
  return `https://www.instagram.com/${encodeURIComponent(handle)}/`;
}

export const INSTAGRAM_LINK_PROPS = {
  target: "_blank",
  rel: "noopener noreferrer",
  referrerPolicy: "no-referrer" as const,
};

/** Instagram post/reel permalink - accepts full URL or shortcode. */
export function instagramPostUrl(permalinkOrCode: string): string {
  const raw = permalinkOrCode.trim();
  if (!raw) return "https://www.instagram.com/";
  if (raw.startsWith("http://") || raw.startsWith("https://")) return raw;
  const code = raw.replace(/^\/+/, "").replace(/\/+$/, "");
  return `https://www.instagram.com/p/${encodeURIComponent(code)}/`;
}
